import { render, staticRenderFns } from "./FPartnerButton.vue?vue&type=template&id=0782b0f4&"
import script from "./FPartnerButton.vue?vue&type=script&lang=ts&"
export * from "./FPartnerButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports